import React, { useState, useEffect } from 'react';

const initialArticles = [
  { id: 1, title: 'Kabinet presenteert nieuwe begroting', status: 'published', date: '2026-03-30' },
  { id: 2, title: 'Verkiezingen in zicht', status: 'published', date: '2026-03-29' },
  { id: 3, title: 'Klimaatwet aangenomen', status: 'draft', date: '2026-03-28' },
];

export default function AdminNews() {
  const [articles, setArticles] = useState(initialArticles);
  const [showForm, setShowForm] = useState(false);
  const [newTitle, setNewTitle] = useState('');

  const handlePublish = () => {
    if (!newTitle) return;
    const newArticle = { id: articles.length + 1, title: newTitle, status: 'published', date: new Date().toISOString().split('T')[0] };
    setArticles([newArticle, ...articles]);
    setNewTitle('');
    setShowForm(false);
    // POST to API
    fetch('https://victor-web.leerheld.workers.dev/admin/articles', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newArticle)
    }).catch(console.error);
  };

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-4xl font-bold">Nieuws beheren</h1>
        <button onClick={() => setShowForm(!showForm)} className="bg-red-600 text-white px-6 py-3 rounded-lg font-bold hover:bg-red-700">
          {showForm ? 'Annuleren' : '+ Nieuw artikel'}
        </button>
      </div>

      {showForm && (
        <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
          <h2 className="text-2xl font-bold mb-4">Nieuw artikel</h2>
          <input type="text" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} placeholder="Artikel titel" className="w-full px-4 py-3 border rounded-lg mb-4" />
          <textarea placeholder="Artikel inhoud..." className="w-full px-4 py-3 border rounded-lg mb-4" rows={6} />
          <button onClick={handlePublish} className="bg-green-600 text-white px-6 py-3 rounded-lg font-bold hover:bg-green-700">
            Publiceren
          </button>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-4 text-left font-semibold text-gray-700">Titel</th>
              <th className="px-6 py-4 text-left font-semibold text-gray-700">Status</th>
              <th className="px-6 py-4 text-left font-semibold text-gray-700">Datum</th>
              <th className="px-6 py-4 text-left font-semibold text-gray-700">Acties</th>
            </tr>
          </thead>
          <tbody>
            {articles.map(article => (
              <tr key={article.id} className="border-t hover:bg-gray-50">
                <td className="px-6 py-4">{article.title}</td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-sm ${article.status === 'published' ? 'bg-green-100 text-green-600' : 'bg-yellow-100 text-yellow-600'}`}>
                    {article.status === 'published' ? 'Gepubliceerd' : 'Concept'}
                  </span>
                </td>
                <td className="px-6 py-4 text-gray-600">{article.date}</td>
                <td className="px-6 py-4">
                  <button className="text-blue-600 hover:text-blue-800 mr-4">Bewerk</button>
                  <button className="text-red-600 hover:text-red-800">Verwijder</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
